import {useDirection} from '@base-ui/react/direction-provider';

import {Icon} from '../Icon';

import type {IconName} from '../Icon';
import type {SVGProps} from 'react';

export type DirectionalIconName =
  | 'chevron-forward'
  | 'chevron-back'
  | 'arrow-forward'
  | 'arrow-back'
  | 'arrow-narrow-forward'
  | 'arrow-narrow-back';

const DIRECTION_MAP: Record<DirectionalIconName, {ltr: IconName; rtl: IconName}> = {
  'chevron-forward': {ltr: 'chevron-right', rtl: 'chevron-left'},
  'chevron-back': {ltr: 'chevron-left', rtl: 'chevron-right'},
  'arrow-forward': {ltr: 'arrow-right', rtl: 'arrow-left'},
  'arrow-back': {ltr: 'arrow-left', rtl: 'arrow-right'},
  'arrow-narrow-forward': {ltr: 'arrow-narrow-right', rtl: 'arrow-narrow-left'},
  'arrow-narrow-back': {ltr: 'arrow-narrow-left', rtl: 'arrow-narrow-right'}
};

export type DirectionalIconProps = SVGProps<SVGSVGElement> & {
  name: DirectionalIconName;
};

export function DirectionalIcon({name, ...props}: DirectionalIconProps) {
  const direction = useDirection();
  const resolvedName = DIRECTION_MAP[name][direction ?? 'ltr'];
  return <Icon name={resolvedName} {...props} />;
}
